(() => {
	angular.module('main').directive('importClientsModal', importClientsModal);

	function importClientsModal(fileDownloadDataService, messageService) {
		return {
			restrict: 'E',
			scope: {
				companyNameChecked: '=',
				client: '=',
				saveClient: '&',
				disableDropzone: '='
			},
			template: `
                    <div id="import-clients-modal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content import-clients-modal-content">
                                <div class="modal-header pt-pb-15">
                                    <btn-close></btn-close>
                                    <h3 class="modal-title">Import clients</h3>
                                </div>
                                <div class="modal-body fs-16" style="padding: 30px!important">
                                    <p>
                                        You can bulk import a large number of clients using CSV file. Please download and use our
                                        CSV file template below.
                                    </p>
                                    <a class="btn btn-success btn-lg" ng-click="downloadClientsTemplate()">Download CSV template</a>
                                    <br><br>
                
                                    <p>
                                        Please make sure you do not reorder, delete or change the column titles within the original CSV
                                        file before uploading it.
                                    </p>
                                    <div ng-hide="disableDropzone" class="dropzone dz-clickable" id="import-clients-dropzone">
                                        <div class="dz-default dz-message">
                                            <span><img src="https://app.studioninja.co/build/release-pipeline-51/resources/dist/assets/images/icons/upload.png" alt=""></span>
                                        </div> 
                                    </div>
                                    <div ng-hide="!disableDropzone" class="dropzone-spinner-container">
                                    	<div class="dropzone-spinner" spinning-wheel is-spinning-wheel-active="disableDropzone" is-spinning-wheel-dark="true"></div>
									</div>       
                                </div>
                            </div>
                        </div>
                    </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.downloadClientsTemplate = function() {
					fileDownloadDataService.saveClientsTemplate().catch(({ error }) => {
						const { errorTitle, errorMessage } = error;
						messageService.showErrorFromBackend(errorTitle, errorMessage);
					});
				};
			}
		};
	}

	importClientsModal.$inject = ['fileDownloadDataService', 'messageService'];
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/importClientsModal.js